import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/categoriaTarifa/';

class PedagioService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  save(cateogira) {
    return axios.post(API_URL + 'salvarCategoriaTarifa', JSON.stringify(cateogira),
      { headers: this.headers });
  }

  getCategoriaTarifa(catTarifaId) {
    return axios.get(API_URL + 'categoriaTarifa/' + catTarifaId, { headers: this.headers });
  }

  findAllPedagioByFiltro(idCliente, filtro) {
    return axios.get(API_URL + 'allCategorias?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
  }

  ativarPedagio(CateogiraId) {
    return axios.post(API_URL + 'ativarCategoria/' + CateogiraId, null, { headers: this.headers });
  }

  inativarPedagio(CateogiraId, dataInativacao) {
    return axios.post(API_URL + 'inativarCategoria/' + CateogiraId + '/' + dataInativacao, null, { headers: this.headers });
  }

  findAllCategoriaByFiltro(idCliente, filtro) {
    return axios.get(API_URL + 'allCategoriaByFiltro?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
  }
}


export default new PedagioService();